import { FC, useContext, useEffect } from "react";
import { UserProgramContext } from "../../context/user-program/user-program";

export const ShopifyProduct: FC = () => {
  const { role } = useContext(UserProgramContext);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
        (function () {
          var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
          if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
              ShopifyBuyInit();
            } else {
              loadScript();
            }
          } else {
            loadScript();
          }
          function loadScript() {
            var script = document.createElement('script');
            script.async = true;
            script.src = scriptURL;
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            script.onload = ShopifyBuyInit;
          }
          function ShopifyBuyInit() {
            var client = ShopifyBuy.buildClient({
              domain: '49b034-0b.myshopify.com',
              storefrontAccessToken: '86b48807b26ac3045b0550b79f40a43a',
            });
            ShopifyBuy.UI.onReady(client).then(function (ui) {
              ui.createComponent('product', {
                id: '9297694032201',
                node: document.getElementById('product-component-1735756592427'),
                moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
                options: {
                  "product": {
                    "styles": {
                      "product": {
                        "@media (min-width: 601px)": {
                          "max-width": "100%",
                          "margin-left": "0",
                          "margin-bottom": "50px"
                        },
                        "text-align": "left"
                      },
                      "title": {
                        "font-size": "26px"
                      },
                      "button": {
                        "font-family": "Arial, sans-serif",
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px",
                        ":hover": {
                          "background-color": "#000000"
                        },
                        "background-color": "#000000",
                        ":focus": {
                          "background-color": "#000000"
                        },
                        "border-radius": "5px",
                        "padding-left": "86px",
                        "padding-right": "86px"
                      },
                      "quantityInput": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                      },
                      "price": {
                        "font-size": "18px"
                      },
                      "compareAt": {
                        "font-size": "15.299999999999999px"
                      },
                      "unitPrice": {
                        "font-size": "15.299999999999999px"
                      }
                    },
                    "layout": "horizontal",
                    "contents": {
                      "img": false,
                      "imgWithCarousel": true,
                      "description": true
                    },
                    "width": "100%",
                    "text": {
                      "button": "Add to cart"
                    }
                  },
                  "productSet": {
                    "styles": {
                      "products": {
                        "@media (min-width: 601px)": {
                          "margin-left": "-20px"
                        }
                      }
                    }
                  },
                  "modalProduct": {
                    "contents": {
                      "img": false,
                      "imgWithCarousel": true
                    },
                    "styles": {
                      "product": {
                        "@media (min-width: 601px)": {
                          "max-width": "100%",
                          "margin-left": "0px",
                          "margin-bottom": "0px"
                        }
                      },
                      "button": {
                        "font-family": "Arial, sans-serif",
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px",
                        ":hover": {
                          "background-color": "#000000"
                        },
                        "background-color": "#000000",
                        ":focus": {
                          "background-color": "#000000"
                        },
                        "border-radius": "5px",
                        "padding-left": "86px",
                        "padding-right": "86px"
                      },
                      "quantityInput": {
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px"
                      },
                      "title": {
                        "font-family": "Helvetica Neue, sans-serif",
                        "font-weight": "bold",
                        "font-size": "26px",
                        "color": "#4c4c4c"
                      },
                      "price": {
                        "font-family": "Helvetica Neue, sans-serif",
                        "font-weight": "normal",
                        "font-size": "18px",
                        "color": "#4c4c4c"
                      },
                      "compareAt": {
                        "font-family": "Helvetica Neue, sans-serif",
                        "font-weight": "normal",
                        "font-size": "15.299999999999999px",
                        "color": "#4c4c4c"
                      },
                      "unitPrice": {
                        "font-family": "Helvetica Neue, sans-serif",
                        "font-weight": "normal",
                        "font-size": "15.299999999999999px",
                        "color": "#4c4c4c"
                      }
                    },
                    "text": {
                      "button": "In den Warenkorb"
                    }
                  },
                  "option": {},
                  "cart": {
                    "styles": {
                      "button": {
                        "font-family": "Arial, sans-serif",
                        "font-size": "18px",
                        "padding-top": "17px",
                        "padding-bottom": "17px",
                        ":hover": {
                          "background-color": "#000000"
                        },
                        "background-color": "#000000",
                        ":focus": {
                          "background-color": "#000000"
                        },
                        "border-radius": "5px"
                      },
                      "title": {
                        "color": "#000000"
                      },
                      "header": {
                        "color": "#000000"
                      },
                      "lineItems": {
                        "color": "#000000"
                      },
                      "subtotalText": {
                        "color": "#000000"
                      },
                      "subtotal": {
                        "color": "#000000"
                      },
                      "notice": {
                        "color": "#000000"
                      },
                      "currency": {
                        "color": "#000000"
                      },
                      "close": {
                        "color": "#000000",
                        ":hover": {
                          "color": "#000000"
                        }
                      },
                      "empty": {
                        "color": "#000000"
                      },
                      "noteDescription": {
                        "color": "#000000"
                      },
                      "discountText": {
                        "color": "#000000"
                      },
                      "discountIcon": {
                        "fill": "#000000"
                      },
                      "discountAmount": {
                        "color": "#000000"
                      }
                    },
                    "text": {
                      "title": "Warenkorb",
                      "total": "Zwischensumme",
                      "empty": "Der Warenkorb ist leer.",
                      "notice": "Rabatte werden im nächsten Schritt ergänzt, sofern verfügbar.",
                      "button": "Jetzt kaufen"
                    },
                    "popup": false
                  },
                  "toggle": {
                    "styles": {
                      "toggle": {
                        "font-family": "Arial, sans-serif",
                        "background-color": "#000000",
                        ":hover": {
                          "background-color": "#000000"
                        },
                        ":focus": {
                          "background-color": "#000000"
                        }
                      },
                      "count": {
                        "font-size": "18px"
                      }
                    }
                  },
                  "lineItem": {
                    "styles": {
                      "variantTitle": {
                        "color": "#000000"
                      },
                      "title": {
                        "color": "#000000"
                      },
                      "price": {
                        "color": "#000000"
                      },
                      "fullPrice": {
                        "color": "#000000"
                      },
                      "discount": {
                        "color": "#000000"
                      },
                      "discountIcon": {
                        "fill": "#000000"
                      },
                      "quantity": {
                        "color": "#000000"
                      },
                      "quantityIncrement": {
                        "color": "#000000",
                        "border-color": "#000000"
                      },
                      "quantityDecrement": {
                        "color": "#000000",
                        "border-color": "#000000"
                      },
                      "quantityInput": {
                        "color": "#000000",
                        "border-color": "#000000"
                      }
                    }
                  }
                }
              });
            });
          }
        })();
      `;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="product-component-1735756592427"></div>;
};
